module.exports = __webpack_public_path__ + "static/media/mission_bg@2x.f1a5f82b.png";